import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators'
import Apis from '@/Apis/_'
import { ModalHistoricoSolicitacao, HistoricoSolicitacao, ProtocolHistory, HistoricoAlteracaoSolicitacao } from '@/types/_'
import { getUser } from '@/utils/common'

@Module({ namespaced: true, name: 'HistoricoSolicitacaoStore' })
export default class HistoricoSolicitacaoStore extends VuexModule {
  modal: ModalHistoricoSolicitacao = {
    historicoSolicitacao: false,
  }

  historicoSolicitacao: HistoricoSolicitacao[] = []
  protocolHistory: ProtocolHistory[] = []
  surgerySolicitationId: string = ''

  @Action
  async getHistoricoSolicitacao(solicitacaoId: string) {
    this.context.commit('setSurgerySolicitationId', solicitacaoId)

    const request = await Apis.Agendamento.HistoricoSolicitacaoApi.get(solicitacaoId)
    if (request.success) {
      this.context.commit('setHistoricoSolicitacao', request.data)
      this.context.commit('setShowModalHistoricoSolicitacao', true)
    }
    return request
  }

  @Mutation
  setShowModalHistoricoSolicitacao(value: boolean) {
    this.modal.historicoSolicitacao = value
  }

  @Mutation
  setHistoricoSolicitacao(value: HistoricoSolicitacao[]) {
    // Mudança do display de Autorizada Parcial para Autorizada Parcial
    const historico = value
    if (getUser().profile.pageAuthorized.includes('agendamento-medico') && value.length > 0) {
      historico.map((item: HistoricoSolicitacao) => {
        const i = item
        if (i.status.key === 'AutorizadaParcial') i.status.display = 'Autorizada Parcial'
        return i
      })
    }
    this.historicoSolicitacao = historico
  }

  @Mutation
  clearHistoricoSolicitacao() {
    this.historicoSolicitacao = []
  }

  @Action
  async getProtocolHistory(surgerySolicitationId: string) {
    const request = await Apis.Agendamento.HistoricoSolicitacaoApi.getProtocolHistory(surgerySolicitationId)

    if (request.success) {
      this.context.commit('setProtocolHistory', request.data)
    }

    return request
  }

  @Mutation
  setProtocolHistory(historyData: ProtocolHistory[]) {
    this.protocolHistory = historyData
  }

  @Mutation
  resetProtocolHistory() {
    this.protocolHistory = []
  }

  @Mutation
  setSurgerySolicitationId(surgerySolicitationId: string) {
    this.surgerySolicitationId = surgerySolicitationId
  }

  @Mutation
  resetSurgerySolicitationId() {
    this.surgerySolicitationId = ''
  }

  /* Historico de alterações */
  historicoAlteracoesSolicitacao: HistoricoAlteracaoSolicitacao[] = []

  @Mutation
  setHistoricoAlteracoesSolicitacao(value: HistoricoAlteracaoSolicitacao[]) {
    this.historicoAlteracoesSolicitacao = value
  }

  @Mutation
  clearHistoricoAlteracoesSolicitacao() {
    this.historicoAlteracoesSolicitacao = []
  }

  @Action
  async getHistoricoDeAlteracoesDaSolicitacao(solicitacaoId: string) {
    try {
      const request = await Apis.Agendamento.HistoricoSolicitacaoApi.getHistoricoDeAlteracoesDaSolicitacao(solicitacaoId)
      if (request.success) this.context.commit('setHistoricoAlteracoesSolicitacao', request.data as HistoricoAlteracaoSolicitacao[] || [])
      return request
    } catch (error) {
      this.context.commit('setHistoricoAlteracoesSolicitacao', [])
      return { success: false, message: 'Ocorreu um erro na requisição.' }
    }
  }
}
